import React, {useEffect} from 'react';
import {Col, Container, Row} from 'reactstrap';
import {DateTime} from 'luxon';
import classNames from 'classnames';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCartPlus} from '@fortawesome/pro-light-svg-icons/faCartPlus';
import {subscribeToCampaign} from 'react-controlled-ab/datalayers/vwo';

import {useUserState} from 'contexts/user';
import {usePhaseState} from 'funnel-schedule/phase-context';
import track from 'utils/track';
import useBeacon from 'utils/useBeacon';
import useBalanceText from 'utils/useBalanceText';

import PageMeta from 'components/PageMeta';
import Video from 'components/Video';
import CheckoutButton from 'components/CheckoutButton';
import CountdownTimer from 'components/CountdownTimer';
import SalesCopy from 'components/SalesCopy';
import {SecurityDisclaimer, TreesRow} from 'components/SalesCta';
import ModalExitSales from 'components/ModalExitSales';
import Footer from 'components/Footer';
import ShareButtons from 'components/ShareButtons';

export default function Impact({
  salesOverride = '',
  noExitIntent = false,
  noTimer = false,
  timerOverride = undefined,
  ...props
}) {
  const userState = useUserState();
  const {email, registrationId} = useUserState();

  const {
    phases: {
      webinar: {phase: webinarPhase = undefined, time = DateTime.utc().toSeconds(), endOfSalesDay = undefined} = {}
    } = {},
    userStateLoaded = false
  } = usePhaseState();

  const phase = props.phase ? props.phase : webinarPhase;
  const isCartClose = DateTime.fromSeconds(time, {zone: 'utc'}).plus({days: 4}) < DateTime.utc();
  const salesFullPrice = (!email && !registrationId && !salesOverride) || (!salesOverride && phase === 'after');
  const timerEnd = timerOverride ? timerOverride : new Date(endOfSalesDay * 1000).getTime();

  const productId = 'tntg';
  const productSku = 'tntg';
  const productName = 'TNTG Impact Kit';
  const productSlug = !salesFullPrice ? 'tntg-impactkit-launch-wlc-30daytrial-st' : 'tntg-impactkit-wlc-30daytrial-st';
  const productValue = salesOverride === 'sales67' ? 67 : !salesFullPrice ? 97 : 197;

  let videoUrl = userStateLoaded
    ? salesOverride !== ''
      ? {
          sales67: 'https://www.youtube.com/watch?v=bxLgVFvNVw8',
          sales97: 'https://www.youtube.com/watch?v=bxLgVFvNVw8'
        }[salesOverride]
      : phase === 'replay'
      ? isCartClose
        ? 'https://www.youtube.com/watch?v=l7Mq3WgOs2I'
        : 'https://www.youtube.com/watch?v=bxLgVFvNVw8'
      : 'https://www.youtube.com/watch?v=fx4TCCF5Y_Q'
    : null;

  useEffect(() => {
    track('Product Viewed', {
      product_id: productId,
      sku: productSku,
      name: productName,
      variant: productSlug,
      value: Number(productValue).toFixed(2),
      currency: 'usd'
    });
  }, [salesFullPrice]);

  function Timer() {
    return (
      <>
        {!salesFullPrice && !noTimer ? (
          <div className="offer-box-timer">
            <h3 className="offer-box-timer-text text-condensed text-800 mb-2 mt-4">Your special discount ends in:</h3>
            <div className="countdown-dark">
              <CountdownTimer time={timerEnd} />
            </div>
          </div>
        ) : null}
      </>
    );
  }

  function CtaBox({trees = false, className = undefined}) {
    return (
      <div className={classNames(`cta-sales cta-sales-${className}`)}>
        <Container>
          <Row className="d-flex justify-content-center">
            <Col xs="12">
              <div className="offer-box offer-box-shadow px-3 py-4 px-sm-4 px-md-5 py-md-5 text-center background-white border-dashed border-green border-5 rounded">
                <div className="offer-box-inner">
                  <Container fluid>
                    <Row className="d-flex justify-content-center">
                      <Col className="text-center">
                        <div className="offer-box-heading">
                          <h3>Support this urgent mission and your health with the Impact Kit!</h3>
                        </div>
                        <Row className="d-flex justify-content-center mb-2">
                          <Col xs="12" lg="8">
                            <img
                              className="img-fluid"
                              src="https://cdn.foodrevolution.org/tntg/tntg-productimage-digitalall.png"
                            />
                          </Col>
                        </Row>
                        {!salesFullPrice ? (
                          <>
                            <h3 className="offer-box-regular-price text-400 mb-2">
                              Regular Price: <del>$197</del>
                            </h3>
                            <h2 className="offer-box-offer-text text-condensed text-800 text-green mx-auto mb-3">
                              {salesOverride ? <>Your Special Offer:</> : <>Limited Time Discount Price:</>} $97
                            </h2>
                          </>
                        ) : (
                          <>
                            <h2 className="text-condensed text-green text-800">Your Price: $197</h2>
                          </>
                        )}
                        <CheckoutButton
                          btnstyle="offer-box-button"
                          sku={productSku}
                          price={productValue}
                          slug={productSlug}
                        >
                          <FontAwesomeIcon
                            className="mr-2"
                            //@ts-ignore
                            icon={faCartPlus}
                          />{' '}
                          Buy Now
                        </CheckoutButton>
                      </Col>
                    </Row>
                    <Timer />
                    <h4 className="text-condensed text-800 mt-4">
                      PLUS Get A Treasured Health Collection ($97 Value!) Completely FREE
                    </h4>
                    <SecurityDisclaimer />
                  </Container>
                </div>
              </div>
            </Col>
          </Row>
          {trees && <TreesRow />}
        </Container>
      </div>
    );
  }

  //useBalanceText();
  useBeacon();
  return (
    <div className="page d-flex flex-column">
      <PageMeta />

      <div className="page-content">
        <div className="background-gradient-yellow-white">
          <div className="background-black triangle-bottom triangle-bottom-black text-white text-center wrapper">
            <div className="offset-header-during">
              <Container>
                <Row className="d-flex justify-content-center">
                  <Col xs="12" sm="10" md="9" lg="12">
                    <h2 className="text-condensed text-800 mb-0">Can we count on you to be part of the SOLUTION?</h2>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
          <div className="video-box offset-video-box-during">
            <Container>
              <Row>
                <Col className="px-0 px-sm-3">
                  {videoUrl && <Video url={videoUrl} label="TNTG - Sales Video - Impact" />}
                </Col>
              </Row>
            </Container>
          </div>

          <div className="pt-5 triangle-angles-offset-bottom text-center">
            <Container>
              <Row>
                <Col>
                  <h2 className="text-condensed text-800 mb-0">
                    Get inspired and <em>stay</em> <br className="d-none d-sm-block d-md-none" />
                    that way <br className="d-none d-xl-block" />
                    with <br className="d-none d-lg-block d-xl-none" />
                    <em>The Need To GROW</em> Impact Kit
                  </h2>
                  <Row className="d-flex justify-content-center">
                    <Col xs="12" lg="8" className="my-4">
                      <img src="https://cdn.foodrevolution.org/tntg/tntg-productimage-digitalall.png" />
                    </Col>
                  </Row>

                  {!salesFullPrice ? (
                    <h2 className="text-condensed text-green text-800">
                      {salesOverride ? <>Your Special Offer:</> : <>Limited Time Discount Price:</>} ${productValue}
                    </h2>
                  ) : (
                    <h2 className="text-condensed text-green text-800">Your Price: $197</h2>
                  )}
                  <CheckoutButton className="offer-box-button" sku={productSku} price={productValue} slug={productSlug}>
                    <FontAwesomeIcon
                      className="mr-2"
                      //@ts-ignore
                      icon={faCartPlus}
                    />{' '}
                    Buy Now
                  </CheckoutButton>
                  <Timer />
                  <SecurityDisclaimer />
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <SalesCopy salesTestimonials salesCta={<CtaBox />} />
      </div>

      <div className="mt-auto">
        <Footer />
        <ShareButtons floating />
      </div>

      {!noExitIntent && <ModalExitSales />}
    </div>
  );
}
